<template>
    <div>
        <v-container fluid pa-0>
            <v-jumbotron class="" :gradient="gradient" style="height: 95vh;">
                <v-container fill-height text-xs-center>
                    <v-layout align-center justify-center>
                        <v-flex sm3>
                            <img src="../assets/logo-beco-svg.svg" style="height: 100px;" class="mb-3">

                            <p class="headline" style="font-weight: bold;">Veja o nosso conteúdo</p>

                            <v-btn to="/home" class="mt-4" dark rounded depressed large style="width:200px; background: -webkit-linear-gradient(left, #4481eb , #04befe) !important;">
                                <v-icon dark left>fas fa-home</v-icon>
                                PRODUTOS
                            </v-btn>

                            <v-btn href="https://medium.com/becodaeletronica" class="mt-4" dark rounded depressed large style="width:200px; background: -webkit-linear-gradient(left, #434343 , #131313) !important;">
                                <v-icon dark left>fab fa-medium-m</v-icon>
                                ARTIGOS
                            </v-btn>

                            <v-btn href="https://www.instagram.com/becodaeletronica/" class="mt-4" dark rounded depressed large style="width:200px; background: -webkit-linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%) !important;">
                                <v-icon dark left>fab fa-instagram</v-icon>
                                INSTAGRAM
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>
        </v-container>
    </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    getImgSVG(path) {
      var images = require.context("../assets/", false, /\.jpg$/);
      return images("./" + path + ".jpg");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/links.vue